export enum IndicatorReportStatus {
  Active = "active", //активный
  Removed = "removed", //удалён
}
